// src/components/Celebrations/CelebrationEventContent.js

// --- Static Content for Celebration Events ---
export const celebrationEventContent = {
  // Keep this object empty for now.
  // When you're ready to add content, use "MM-DD" as keys (e.g., "01-26" for Republic Day):
  /*
  "01-26": { // Example: Republic Day (MM-DD format)
    details: {
      faqs: [
        {
          id: 'republicday-q1',
          question: 'What is Republic Day?',
          answer: 'Republic Day is a national festival of India...'
        }
      ]
    },
    activities: {
      staticActivities: [
        {
          category: "School Celebrations",
          activities: [
            { id: 'ca1', name: 'Flag Hoisting Ceremony', description: 'Annual flag hoisting with patriotic songs.' },
            // ... more activities
          ]
        }
      ]
    },
    speeches: {
      staticSpeeches: {
        shortSpeech: [
          { title: "On Republic Day", content: "..." }
        ],
        longSpeech: [
          { title: "The Spirit of India", content: "..." }
        ]
      },
      aiPrompts: [
        "Write a speech for Republic Day on unity.",
        // ... more prompts
      ]
    },
    projects: {
      // Specific static projects if any, otherwise fetched dynamically
    }
  },
  "08-15": { // Example: Independence Day (MM-DD format)
    details: { ... },
    activities: { ... },
    speeches: { ... },
    projects: { ... }
  }
  */
};